<template>
    <keep-alive>
        <div class="wrap-simcard-list">
            <div class="wrap-simcard-list_top">
                <div class="simcard-list_fiters_toggler" :class="{active: filters_state}" @click="toggleFiltersState">
                    <span class="mdi" :class="(filters_state === true)? 'mdi-filter-remove': 'mdi-filter'" @click="toggleFiltersState"/>
                    <span class="simcard-list_fiters_toggler_text">
            {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
          </span>
                </div>

                <div class="simcard-list_fiters_is" :class="(filters_state === true)? 'show' : 'hidden'">
                    <sis-select
                            :options="opt_group"
                            :options_limit="100"
                            :label="translate('simcard_devices_group_list.many')"
                            :placeholder="translate('simcard_devices_group_list.many')"
                            v-model="filter_simcard_devices.group"
                            :multiple="true"
                            :flat="true"
                            :close_on_select="false"
                            clear-on-select="true"
                            :hide_selected="true"
                            :preserveSearch="true"
                            :max_height="165"
                            :select-label="translate('select_enter')"
                            :noresult="translate('group.not_found')"
                            @input="change_group"
                    />
                </div>
                <button
                        class="reset-filters-btn  mdi-refresh mdi"
                        :class="(status_filter())? '' : 'is--no-active'"
                        @click.prevent="reset_filter"
                >
                    {{ translate('filter.reset') }}
                </button>
            </div>

            <div class="response_table">
                <table>
                    <thead
                            ref="tableHead"
                            class="table-simcard-list_bg"
                            :class="(filters_state)? 'simcard-list_fiters_is--show' : 'simcard-list_fiters_is--hidden'"
                    >
                    <tr>
                        <th scope="col" class="checkbox_table">
                            <input type="checkbox" :checked="checkall" @change="checkAll">
                        </th>
                        <th scope="col" class="status table-simcard-list_mob-filters">
                            <toggle-switch-simcard-status
                                    v-model="filter_simcard_devices.status"
                                    :disabled="false"
                                    :name="name"
                                    @toggle="change_status"
                                    @selected="selectedMethod()"
                            />
                        </th>
                        <th scope="col" class="table-simcard-list_mob-filters">
                            <tag-list-popup
                                    v-model="filter_simcard_devices.device_fid"
                                    :label="translate('simcard_devices.fid')"
                                    @input="change_input"
                            />
                        </th>
                        <th scope="col" class="table-simcard-list_mob-filters">
                            <tag-list-popup
                                    v-model="filter_simcard_devices.name"
                                    :label="translate('simcard_devices.name')"
                                    @input="change_input"
                            />
                        </th>
                        <th scope="col" class="table-simcard-list_mob-filters">
                            <tag-list-popup
                                    v-model="filter_simcard_devices.number"
                                    :label="translate('simcard_devices.number')"
                                    @input="change_input"
                            />
                        </th>
                        <th scope="col" class="table-simcard-list_mob-filters">
                            <tag-list-popup
                                    v-model="filter_simcard_devices.imsi"
                                    :label="translate('simcard_devices.imsi')"
                                    @input="change_input"
                            />
                        </th>
                        <th scope="col" class="table-simcard-list_mob-filters">
                            <tag-list-popup
                                    v-model="filter_simcard_devices.iccid"
                                    :label="translate('simcard_devices.iccid')"
                                    @input="change_input"
                            />
                        </th>
                        <th style="width: 15px" />
                    </tr>

                    <tr>
                        <th v-if="head_tr" class="group_res">
                            {{ head_tr }}
                        </th>
                    </tr>
                    </thead>
                    <tbody ref="tableSimcard" style="position: relative" @scroll.passive="paint_chart($event)">
                    <tr v-if="load" style="border:none; background-color:  transparent;">
                        <td> <scale-loader /> </td>
                    </tr>
                    <SimCardDevicesListItem
                            v-for="(item,index) in trs"
                            class="simcard_item"
                            ref="mySimcard"
                            :key="index"
                            :index="index"
                            :item="item"
                            :checked="item.checked"
                            @check="resetCheck"
                    />
                    <tr v-if="afterload" style="border:none; background-color:  transparent;" >
                        <td> <scale-loader /> </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </keep-alive>
</template>
<script>

import SisSelect from 'components/UIComponents/Inputs/SisSelect.vue'
import SimCardDevicesListItem from './SimCardDevicesListItem.vue'
import ToggleSwitchSimcardStatus from 'components/UIComponents/ToggleSwitch/ToggleSwitchSimcardStatus.vue'
import TagListPopup from 'components/UIComponents/Tags/TagListPopup.vue'

export default {
    name: 'SimCardDevicesList',
    components: {
        SimCardDevicesListItem,
        SisSelect,
        ToggleSwitchSimcardStatus,
        TagListPopup
    },
    data () {
        return {
            loading: true,
            range: false,
            cur_item: {},
            load: true,
            top: 0,
            ids: [],
            interval_update: null,
            afterload: false,
            group_cnt: {},
            tableData: {},
            trs: [],
            timer: null,
            timer_res: null,
            name: '',
            cur_pages: 0,
            pages: 0,
            timer_chart: null,
            menuData: {},
            rendList: [],
            resizeList: [],
            checkall: false,
            was_checkall: false,
            uncheckList: {},
            filter_simcard_devices: {},
            head_tr: '',
            group_head: [],
            status_option: [],
            filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
            date: [],
            dateReport: [],
            sims_sort: 'asc',
        }
    },
    computed: {
        opt_group () {
            return this.$store.getters.getSimcardDevicesGroupsTree
        },
        proveCopy () {
            return (navigator.clipboard !== undefined)
        },
    },

    watch: {
        opt_group () {
            this.$nextTick( () => {
                if (this.group_head.length > 0) {
                    this.group_head[0].$el.style.display = 'none'
                    if (this.$refs.tableSimcard.scrollTop <= 50) {
                        this.head_tr = this.group_head[0].$el.firstChild.innerHTML
                    }
                }
            } )
        },
        tableData () {
            var trs = [] // 0 - название группы, 1 - элемент
            let t = {}
            this.group_head = []
            for (let i in this.tableData) {
                t = {'type': 0, id: i, count: this.group_cnt[i].cnt, online: +this.group_cnt[i].online}
                trs.push(t)
                for (let j in this.tableData[i]) {
                    this.tableData[i][j].checked = false
                    if ((this.online && this.tableData[i][j].status) || !this.online) {
                        this.tableData[i][j].type = 1
                        this.tableData[i][j].checked = this.was_checkall
                        trs.push(this.tableData[i][j])
                    }
                }
                // trs.push(t)
            }

            if (trs.length === 0) {
                this.head_tr = 'No result'
                this.trs = []
            } else {
                this.$set(this, 'trs', trs)
            }

            this.load = false
            this.afterload = false
            this.$nextTick(this.mountItem)
            return true
        }
    },
    created () {
        this.init()
        window.addEventListener('resize', this.handleResize)
    },
    activated () {
        this.$refs.tableSimcard.scrollTop = this.top
        if (this.$store.getters.getDeviceListChange) {
            this.init()
            this.$store.commit('setSimcardDevicesListChange', false)
        } else {
            clearInterval(this.interval_update)
            this.interval_update = setInterval(this.update_status, this.$store.getters.getSimcardDevicesListUpdate)
        }

        window.addEventListener('resize', this.handleResize)
    },

    beforeDestroy: function () {
        window.removeEventListener('resize', this.handleResize)
    },

    deactivated () {
        this.top = this.$refs.tableSimcard.scrollTop
        clearInterval(this.interval_update)
        window.removeEventListener('resize', this.handleResize)
    },

    methods: {
        get_simcard () {
            this.ids = []
            this.load = true
            this.group_head = []

            clearInterval(this.interval_update)
            this.interval_update = setInterval(this.update_status, this.$store.getters.getSimcardDevicesListUpdate)
            this.rendList = []

            let filter_simcard_devices = this.filter_simcard_devices
            this.$store.dispatch('setSimcardDevicesFilter', filter_simcard_devices)
            this.localStorage.setItem('filter_simcard_devices', JSON.stringify(filter_simcard_devices))
            this.$http.v1.getPagesSimcards(filter_simcard_devices, (response) => {
                this.pages = response.data.pages

                for (let group of response.data.group) {
                    this.group_cnt[group.group_id] = group
                }
                // this.group_cnt = response.data.group

                this.hash = response.data.hash
                this.$http.v1.getSimcardList({...filter_simcard_devices, 'page': this.cur_page = 0}, (response) => {
                    this.tableData = {...response.data.sim}
                    this.ids = [...response.data.ids]
                })
            })
        },
        getReport () {
            let filter_simcard_devices = this.filter_simcard_devices

            if(this.was_checkall) {
                filter_simcard_devices['not_id'] = Object.keys(this.uncheckList)
            }
            else {
                let checkedList = []
                for (let i in this.tableData) {
                    for (let j in this.tableData[i]) {
                        if (this.tableData[i][j].checked) {
                            checkedList.push(this.tableData[i][j].device_id)
                        }
                    }
                }
                if (checkedList.length === 0)  {
                    this.global_notify('danger', this.translate('device.no_chosen'))
                    this.loading = true
                    return false
                } else {
                    filter_simcard_devices['ids'] = checkedList
                }
            }
            // this.$http.api.addReport( {start: +this.dateReport[0], end: +this.dateReport[1], ...filter_simcard_devices}, (response) => {
            //   if(response.data.status) {
            //     this.global_notify('info', this.translate('report.added'))
            //   }
            // })
        },
        disabledTwoMonth(dateReport) {
            const today = new Date();
            return dateReport > new Date(today.getTime()) || dateReport < new Date(today.getTime() - 60 * 24 * 3600 * 1000);
        },
        update_status () {
            this.date = new Date()
            this.$http.v1.getPagesSimcards(this.filter_simcard_devices, (response) => {
                this.page = response.data.pages
                this.group = response.data.group
                for (let i = 0; i <= this.cur_page; i++) {
                    setTimeout(() => {
                        this.$http.v1.getSimcardList({...this.filter_simcard_devices, 'page': i}, (response) => {
                            for (let i in response.data.sim) {
                                if (this.tableData[i] === undefined) {
                                    this.tableData[i] = {}
                                }
                                for (let j in response.data.sim[i]) {
                                    if (this.tableData[i][j] === undefined) {
                                        this.tableData[i][j] = {}
                                    }
                                    this.tableData[i][j] = response.data.sim[i][j]
                                    this.tableData[i][j].offline = response.data.sim[i][j].offline
                                }
                            }
                        })
                    }, 300)
                }
            })
        },
        change_group () {
            this.change_input()
        },
        change_status (name, value) {
            this.filter_simcard_devices.status[name] = value
            this.change_input()
        },

        handleResize () {
            if (this.timer_res !== null) {
                clearTimeout(this.timer_res)
            }
            this.timer_res = setTimeout(() => { this.resizeList = [...this.$refs.mySimcard]; this.paint_chart() }, 300)
        },
        checkAll () {
            this.checkall = !this.checkall
            this.was_checkall = this.checkall
            this.tableData = {...this.tableData}
            this.uncheckList = {}
        },
        resetCheck (check, dev_id) {
            if(this.checkall) {
                this.was_checkall = true
            }
            if(this.was_checkall && !check && this.uncheckList[dev_id] === undefined) {
                this.uncheckList[dev_id] = 1
            } else {
                delete this.uncheckList[dev_id]
            }
            this.checkall = false
        },
        status_filter () {
            for (let i in this.filter_simcard_devices) {
                if (i === 'status') {
                    for (let j in this.filter_simcard_devices.status) {
                        if (this.filter_simcard_devices.status[j]) {
                            return true
                        }
                    }
                } else {
                    if (this.filter_simcard_devices[i].length > 0) {
                        return true
                    }
                }
            }
            return false
        },
        get_filter () {
            let arr = {name: [], group: [], number: [], device_fid: [], iccid: [], imsi: [], status: { online: false, blocked: false, crit_traffic: false }}
            let res = {}

            let filter_simcard_devices = JSON.parse(this.localStorage.getItem('filter_simcard_devices'))

            if (filter_simcard_devices !== null) {
                for (var i in arr) {
                    if (filter_simcard_devices[i] !== undefined) {
                        res[i] = filter_simcard_devices[i]
                    } else {
                        res[i] = arr[i]
                    }
                }
            } else {
                res = arr
            }
            return res
        },

        init () {
            this.filter_simcard_devices = this.get_filter()
            this.date = new Date()
        },

        paint_chart () {
            let tmpRend = []
            let table = this.$refs.tableSimcard
            for (let i in this.group_head) {
                if (this.group_head[i].$el.offsetTop <= (table.scrollTop - this.group_head[i].$el.clientHeight)) {
                    this.head_tr = this.group_head[i].$el.firstChild.innerHTML
                }
            }
            for (let i in this.resizeList) {
                if ((this.resizeList[i].$el.offsetTop > (table.scrollTop - 40)) && this.resizeList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
                    if (this.resizeList[i].chartStatus === true) {
                        this.resizeList[i].resize = !this.resizeList[i].resize
                    }
                } else {
                    tmpRend.push(this.resizeList[i])
                }
            }

            if (tmpRend.length > 0) {
                this.resizeList = [...tmpRend]
            }

            tmpRend = []
            for (let i in this.rendList) {
                if ((this.rendList[i].$el.offsetTop > (table.scrollTop - 40)) && this.rendList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
                    this.rendList[i].chartStatus = true
                } else {
                    tmpRend.push(this.rendList[i])
                }
            }
            this.rendList = tmpRend
            if ((table.scrollTop >= table.scrollHeight - (table.clientHeight * 3)) && !this.afterload) {
                if (this.cur_page < this.pages) {
                    this.add_simcard_in_list()
                }
            }
        },

        mountItem () {
            if (this.trs.length === 0) {
                return false
            }
            let length = (this.$refs.mySimcard.length < 25) ? this.$refs.mySimcard.length : 25

            // for (let i = 0; i < length; i++) {
            //   this.$refs.mySimcard[i].chartStatus = true
            // }
            if (length < this.$refs.mySimcard.length) {
                for (let i = 25; i < this.$refs.mySimcard.length; i++) {
                    this.rendList.push(this.$refs.mySimcard[i])
                }
            }
            for (let i = 0; i < this.$refs.mySimcard.length; i++) {
                if (this.$refs.mySimcard[i].item.type === 0) {
                    this.group_head.push(this.$refs.mySimcard[i])
                }
            }
            if (this.group_head.length > 0) {
                this.group_head[0].$el.style.display = 'none'
                // if (this.head_tr === '' || this.head_tr === 'No result') {
                if (this.$refs.tableSimcard.scrollTop <= 50) {
                    this.head_tr = this.group_head[0].$el.firstChild.innerHTML
                }
            }
        },
        change_input () {
            if (this.timer !== null) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(this.get_simcard, 1000)
        },

        reset_filter () {
            this.filter_simcard_devices = {name: [], group: [], number: [], device_fid: [], iccid: [], imsi: [], status: { online: false, blocked: false, crit_traffic: false }}
            this.change_input()
        },

        add_simcard_in_list () {
            if (this.cur_page+1 < this.pages) {
                this.afterload = true
                this.$http.v1.getSimcardList({...this.filter_simcard_devices, 'page': ++this.cur_page}, (response) => {
                    let tmp = {...this.tableData}
                    for (let i in response.data.sim) {
                        if (tmp[i] === undefined) {
                            tmp[i] = {}
                        }
                        for (let j in response.data.sim[i]) {
                            tmp[i][j] = response.data.sim[i][j]
                        }
                    }
                    this.tableData = {...tmp}
                    this.ids = [...this.ids, ...response.data.ids]
                })
            }
        },
        add_task () {
            let checkedList = []
            for (let i in this.tableData) {
                for (let j in this.tableData[i]) {
                    if (this.tableData[i][j].checked) {
                        checkedList.push(this.tableData[i][j].device_id)
                    }
                }
            }
            if (checkedList.length < 1) {
                this.global_notify('danger', this.translate('device.no_chosen'))
                return false
            }
        },
        toggleFiltersState () {
            this.filters_state = !this.filters_state
            this.localStorage.setItem('filters_state', this.filters_state)
        }
    }
}
</script>
<style lang="scss">

.wrap-simcard-list{
  display: flex;
  flex-direction: column;
  height: 100%;
  .response_table{
    padding: 0;
    .checkbox_table {
      width: 30px;
      height: 50px;
    }
    .simcard_item{
      cursor: pointer;
      &:hover{
        background-color: #eee;
        color: black;
        tr{
          background-color: #f1f1f1;
        }
      }
    }
  }
  &_top {
    margin: 2.25rem 0 -6px;
    padding: 1vh 1vh 1vh 1vh;
    background: #FFF;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #dddddd;
    border-bottom: none;
    .simcard-list_fiters_toggler {
      position: absolute;
      right: 50%;
      top: -3px;
      margin: -2rem -6.5rem auto auto;
      font-size: 1.15rem;
      line-height: 2rem;
      width: 13rem;
      height: 2.25rem;
      color: #66615b;
      cursor: pointer;
      z-index: 20;
      background: #FFF !important;
      text-align: center;
      border-radius: 5px 5px 0 0;
      border: 1px solid #ddd;
      border-bottom: none;
      &_text{
        color: #66615b;
        border-bottom: 1px dashed #ccc;
        margin-top: -1px;
        line-height: 1.12rem;
        display: inline-block;
        vertical-align: middle;
      }
      &.active{
        span{
          color: #ccc;
        }
      }
    }
    .simcard-list_fiters_is {
      width: 40%;
      transition: all ease 0.15s, opacity ease 0.25s;
      &.show{
        opacity: 1;
      }
      &.hidden{
        opacity: 0;
      }
      .form-group{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        .manage_btn{
          margin-left: 0;
        }
      }
    }
  }
}
.table-simcard-list_mob-filters__traffic{
  font-size: 0.95rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  cursor: pointer;
  .mdi{
    transition: 0.2s;
    &::before{
      transform: rotate(180deg);
    }
    &.reverse::before{
      transform: rotate(0);
    }
  }
}

</style>
